// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/styles/app.css
// module id = 815
// module chunks = 1